function SkuLine({ sku, showDetails }) {
  return (
    <>
      <tr role={'button'}>
        <td>{sku.No}</td>
        <td>{sku.Description}</td>
        <td>{sku.Type}</td>
        <td>{sku.Unit_Cost}€</td>
        <td>{sku.Last_Date_Modified}</td>
        <td className="overlay-edit pr-5">
          <button type="button" className="btn btn-icon btn-info" onClick={() => showDetails(sku)}>
            <i className="feather icon-eye"></i>
          </button>
        </td>
      </tr>
    </>
  );
}

export default SkuLine;
